import { clsx } from 'clsx'
import './index.scss'

interface Props {
    children?: TChild
    className?: string
    loading?: boolean
    size?: number
    width?: number
    status?: string
}

const CircleIndicator = ({
    children,
    className,
    loading,
    size = 120,
    width = 4,
}: Props) => {
    return (
        <div
            className={clsx([
                'circle-indicator',
                loading && 'is-loading',
                className,
            ])}
            data-testid={`loading-indicator`}
            style={
                {
                    '--indicator-size': `${size}px`,
                    '--border-width': `${width}px`,
                } as TCSSProperties
            }
        >
            <div className="circle"></div>

            {children && (
                <div className="circle-indicator-content">{children}</div>
            )}
        </div>
    )
}

export default CircleIndicator
